export const designTagsSelector = (state) => state.api.designTags;
